import React, {useEffect, useRef, useState} from 'react';
import MaterialTable from 'material-table';
import { NavLink } from 'react-router-dom';
import { TablePagination } from '@material-ui/core';
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import { clearCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import { MoreVertRounded } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { ThumbDown, ThumbUp } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DataIconsTooltip from '../StationDetails/Tooltip/DataIconsTooltip';

import API_PATH from "../../constants/config.json";
import TableIcons from '../TableIcons';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

let searchTerm = "";


const EditLaneGeometrySwitch = withStyles((theme) => ({
    root: {
        width: 44,
        height: 24,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(20px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#2563EB',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#2563EB',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 22,
        height: 22,
    },
    track: {
        borderRadius: 24,
        border: `1px solid #E4E4E7`,
        backgroundColor: '#E4E4E7',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {}
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const SharedFiles = (props) =>{

    let history = useHistory();
    const [fileList, setFileList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [hover, setHower] = React.useState(false);
    const [getSearchTerm, setSearchTerm] = React.useState("");
    const refContainer = useRef('');
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [isPublicDownloadAllowed, setIsPublicDownloadAllowed] = useState(false);

    const tableRef = useRef();
    const [checkedFiles, setCheckedFiles] = useState([]);

    const enteriesPerPage = 25;
    let values = {
        "pageNo": pagination.selectedPage,
        "entriesPerPage": enteriesPerPage,
    }

    const handleSwitchPublicDownloadAllowed = () => {
        try{
            axios({
                method: 'post',
                data: {
                    public_download_allowed: !isPublicDownloadAllowed
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.updateIsPublicDownloadAllowed,
            })
                .then(async function (response) {
                    setIsPublicDownloadAllowed(!isPublicDownloadAllowed)
                    if (response.status && response.status == '200') {
                        let fileData = response.data.data.rows;
                        setLoaderDisable(false);                      
                        setFileList(fileData);
                        setTotalItems(response.data.data.count);
                    } else {
                        setFileList([]);
                        setLoaderDisable(false);
                    }
                })
                .catch(async function (error) {
                    setLoaderDisable(false);
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
            setLoaderDisable(false);
        }
    }

    useEffect(
        () => {
            if(props.needToReload) {
                setCheckedFiles([]);
                getFilesAPI(pagination.selectedPage);
            }
        }, [props.needToReload]
    )

    const getFilesAPI = (page = 1, search = "", enable = false) => {
        setLoaderDisable(true);
        let enableV = search !== "" || searchTerm !== "" ? true : enable;
        try {
            axios({
                method: 'post',
                data: {
                    pageNo: page,
                    entriesPerPage: enteriesPerPage,
                    searchEnable: enableV,
                    searchValue: search !== "" ? search : searchTerm,
                    is_public: true
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.allPublicFileList,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let fileData = response.data.data.rows;
                        setIsPublicDownloadAllowed(fileData[0].public_download_allowed)
                        setLoaderDisable(false);                      
                        setFileList(fileData);
                        setTotalItems(response.data.data.count);
                    } else {
                        setFileList([]);
                        setLoaderDisable(false);
                    }
                })
                .catch(async function (error) {
                    setLoaderDisable(false);
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
            setLoaderDisable(false);
        }
    }

    const handleSelected = (e, selectedPage) => {
        values.pageNo = selectedPage + 1;
        let page = values.pageNo
        setPagnation({ selectedPage: selectedPage + 1 })
        getFilesAPI(page);
    }

    const kekPressSearch = (e) => {    
        if(e.key === 'Enter'){
          e.preventDefault();
          onSearch();
        }    
    }

    const searchField = (e) => {
        setHower(true)    
        searchTerm = e.target.value;   
        getFilesAPI(1, e.target.value, true)
        setPagnation({ selectedPage: 1 })    
    }

    const onSearch = () => {   
        if(searchTerm == ''){      
            return;
        }
        getFilesAPI(1, searchTerm, true)
        setPagnation({ selectedPage: 1 })
    }

    const clearText = () => {
        refContainer.current.reset();
        searchTerm = "";
        getFilesAPI(1, "", false);
        setPagnation({ selectedPage: 1 })
    }

    const handleCheckFile = (rows) => {
        setCheckedFiles(rows);
    }
    
    const handleFileStatus = (action) => {
        let ids = [];
        checkedFiles.forEach(function(row, ind) {
            ids.push(row.file_id);
        });
        if(action === 'unshare'){
            props.shareFile(action, ids);
        } else {
            let stID = action === 'approve' ? 3 : 5;
            props.changeFileStatus(stID, ids);
        }
    }

    return(
        <React.Fragment>  
            <div className="table-top">
                <h3>{API_PATH.sharedWording} storage files</h3>
                <form ref={refContainer} noValidate autoComplete="off">
                   <DataIconsTooltip title="Allow non-logged in users to export count summary pdf and csv files">
                        <FormControlLabel
                            control={<EditLaneGeometrySwitch checked={isPublicDownloadAllowed} onChange={(e) => handleSwitchPublicDownloadAllowed()} />}
                            label={<Typography className={{}}>Allow non-logged in users to export{isPublicDownloadAllowed}</Typography>}
                        />
                    </DataIconsTooltip>
                    <Button disabled={checkedFiles.length === 0} onClick={()=>handleFileStatus('unshare')}><img src={require('../../assets/icons/management_menu/file-unsharing.svg')} /> {API_PATH.unsharedWording}</Button>
                    <TextField
                    id="input-with-icon-textfield"
                    placeholder="Search"
                    onChange={(e) => searchField(e)}
                    onKeyPress={(e) => kekPressSearch(e)}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start" onClick={onSearch}>
                            <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            {hover && <FontAwesomeIcon icon={faTimes} onClick={clearText} />}
                        </InputAdornment>
                        ),
                    }}
                    />      
                </form>
            </div>   
            <div className={props.scrolled ? "table-container scrolled-el" : "table-container"} onScroll={() => props.handleScroll(tableRef)} ref={tableRef}>
                <MaterialTable
                    icons={TableIcons}
                    title=""
                    columns={[
                    { title: 'Station ID', field: 'client_station_id', width: '15%',
                        render: rowData => 
                        <NavLink to="#" onClick={() => props.handleGoToDetails(rowData)}>
                            <label title={rowData.client_station_id}>{rowData.client_station_id.length > 16 ? rowData.client_station_id.substring(0, 15)+'...' : rowData.client_station_id}</label>
                        </NavLink> 
                    },
                    { title: 'File name', field: 'filename', width: '38%',
                        render: rowData => 
                        {
                            return <>
                            {
                                rowData.bucket_name === 'N/A' || !rowData.bucket_name || rowData.bucket_name === '' ?
                                <NavLink to="#">
                                    <label title={rowData.filename}>{rowData.filename.length > 45 ? rowData.filename.substring(0, 44)+'...' : rowData.filename}</label>
                                    {props.loader.filename === rowData.file_id && props.loader.loader ? <CircularProgress /> : null}
                                </NavLink>  
                                :
                                <NavLink to="#" onClick={() => props.downloadFile(rowData.file_id, rowData.bucket_name, rowData.base_name, rowData.filename)}>
                                    <label title={rowData.filename}>{rowData.filename.length > 45 ? rowData.filename.substring(0, 44)+'...' : rowData.filename}</label>
                                    {props.loader.filename === rowData.file_id && props.loader.loader ? <CircularProgress /> : null}
                                </NavLink>  
                            }
                            </>
                        }
                    },
                    { title: 'Date', field: 'createdAt', width: '12%', 
                        render: rowData => {
                            var dt = new Date(rowData.createdAt);
                            let day = dt.getDate()<10?'0'+dt.getDate(): dt.getDate();
                            let month = (dt.getMonth()+1)<10 ? '0'+(dt.getMonth()+1) : dt.getMonth()+1;
                            return `${month}/${day}/${dt.getFullYear()}`;
                        }
                    },
                    { title: 'Imported by', field: 'email', width: '20%', },
                    { title: 'Actions', field: '', width: '10%', cellStyle: { textAlign: 'center' },
                        render: rowData => 
                        <MoreVertRounded 
                        className={ (rowData.status!=='Approved' && rowData.status!=='Ready') || rowData.bucket_name === 'N/A' || !rowData.bucket_name || rowData.bucket_name === '' ? "actions-dots-disabled" : "actions-dots"}
                            onClick={(e) => props.handleShowActions(e,rowData.file_id, rowData.status,rowData.is_public,rowData)} 
                        /> 
                    },
                    ]}
                    data={fileList ? fileList : []}
                    totalCount={totalItems}
                    options={{
                        filtering: false,
                        sorting: false,
                        // paging: true,
                        paging: totalItems > 25 ? true : false,
                        pageSize: enteriesPerPage,
                        pageSizeOptions: [0],
                        search:false,
                        emptyRowsWhenPaging: false,
                        selection: true,
                        draggable: false
                    }}
                    onSelectionChange={(rows) => handleCheckFile(rows)}
                    components={
                        getLoader == false?
                        fileList.length === 0 ? 
                            { 
                                Body: () => (
                                    <tbody>
                                        <tr style={{ height: '380px' }}>
                                            <td colspan="6" className="empty-state">
                                                <img src={require('../../assets/icons/empty-files-table.svg')} />
                                                <label>No files here</label>
                                                <p>Once you share some files they will appear here!</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            } 
                            :
                            {
                                Pagination: props => (
                                    <TablePagination
                                    {...props}
                                    count={totalItems}
                                    page={pagination.selectedPage - 1}
                                    onChangePage={handleSelected}
                                    rowsPerPage={enteriesPerPage}
                                    />
                                ),
                            }
                        :
                        {
                            Pagination: props => (
                            <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                            />
                            ),
                            Body: (props) => (
                            <tbody><tr style={{ height: '49px' }}><td colspan="6" style={{ width: '100%', paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                            )
                        }
                        
                    }
                />
            </div>
        </React.Fragment>
    );
}
export default SharedFiles;